export default __webpack_public_path__ + "static/Entenda0147-1b856757f56a2073b401c91fae3d634a.jpg";